export enum EnvironmentTypeEnum {
  DEV = 'development',
  STAG = 'staging',
  PROD = 'production',
  PPE = 'ppe',
}
